import { OrderSet } from '@exodus/models';
const resultFunction = (orders = OrderSet.EMPTY) => (txID) => !!orders.getByTxId(txID);
const getIsExchangeTxSelectorDefinition = {
    id: 'getIsExchangeTx',
    resultFunction,
    dependencies: [{ selector: 'data' }],
};
export default getIsExchangeTxSelectorDefinition;
